var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("YEARLY PLAN")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "relative w-100"
        }, [_c('CustomNav', {
          attrs: {
            "items": _vm.tabs
          },
          on: {
            "item-click": function itemClick(value) {
              return _vm.activeTab = value;
            }
          }
        }), _vm.activeTab === 'fleet_availability_target' ? [_c('AvailabilityTarget')] : [_c('MaintenanceDocking')]], 2)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }